<template>
    <tr :class="{'eco-participation-line': line.is_eco_participation, 'ix-table-row-hidden-from-client': (canHide || showsHiddenFlag) && line.is_hidden_from_client}">
        <td class="text-center">
            <span class="ix-drag-icon handle-line" v-if="!line.is_eco_participation"></span>
        </td>
        <td class="text-center">
            <span 
                v-b-tooltip.hover.right="hover_label">
                <input type="checkbox" 
                :disabled="line.amount != 0 || (editable ? false : true) || isProtectedArticle"
                value="1" 
                :id="'is_title_' + line.uniq" 
                :name="'lines[' + index + '][is_title]'"
                v-model="line.is_title"
                @change="compute">
            </span>
            <input type="hidden" v-if="line.amount != 0 || editable ? false : true" value="1"  :name="'lines[' + index + '][is_title]'"/>
        </td>
        <td>
            <input type="text" class="form-control form-control-sm" :name="'lines[' + index + '][reference]'" v-model="line.reference"  :disabled="line.is_eco_participation || (editable ? false : true)">
            <input type="hidden" :name="'lines[' + index + '][reference]'" v-model="line.reference"  v-if="line.is_eco_participation || (editable ? false : true)">
        </td>
        <td>
            <div class="input-group">
                <div class="input-group-prepend" v-if="line.article_id || line.is_eco_participation || line.is_shipping">
                    <!-- Un kit : l'icône déplie la composition ; le chevron de la ligne garde la description. -->
                    <button type="button" class="input-group-text ix-line-kit-toggle" :class="{'is-open': line.kit_open}"
                            v-if="line.kit && !line.is_eco_participation"
                            v-b-tooltip="tooltip(kit_label)"
                            @click="toggleKit">
                        <i class="far fa-cubes"></i>
                        <i class="far fa-angle-down ml-1" :class="{'fa-rotate-180': line.kit_open}"></i>
                    </button>
                    <span class="input-group-text" v-else>
                        <i class="far fa-cube" v-if="line.article_id && !line.is_eco_participation"></i>
                        <i class="far fa-recycle" v-if="line.is_eco_participation"></i>
                        <i class="far fa-truck" v-if="line.is_shipping && !line.article_id" v-b-tooltip="tooltip('Ligne de frais de port')"></i>
                    </span>
                </div>
                <input placeholder="Commencer la saisie pour obtenir des suggestions .." class="form-control form-control-sm" :id="'suggestionAutocomplete' + line.uniq" type="text" :name="'lines[' + index + '][designation]'" v-model="line.designation" @input="emitEventLineEdited" :required="line.amount != 0 && line.is_title != 1"  :disabled="line.is_eco_participation || (editable ? false : true)">
                <div class="input-group-append" v-if="canCreateArticle && editable && !line.is_eco_participation && line.is_title != 1">
                    <button type="button" class="ix-btn ix-btn-icon blue" v-b-tooltip="tooltip(line.article_id ? 'Copier en nouvel article' : 'Nouvel article')" @click="openArticleModal">
                        <i class="far fa-plus"></i>
                    </button>
                </div>
            </div>
            <input type="hidden" :name="'lines[' + index + '][id]'" v-model="line.id">
            <input type="hidden" :name="'lines[' + index + '][designation]'" v-model="line.designation" v-if="line.is_eco_participation || (editable ? false : true)">
            <input type="hidden" :name="'lines[' + index + '][parent_id]'" v-model="line.parent_id">
            <input type="hidden" :name="'lines[' + index + '][article_id]'" v-model="line.article_id">
            <input type="hidden" :name="'lines[' + index + '][under_total]'" v-model="line.under_total"> 
            <input type="hidden" :name="'lines[' + index + '][description]'" v-model="line.description" v-if="line.is_eco_participation || (editable ? false : true)"> 
            <input type="hidden" :name="'lines[' + index + '][is_eco_participation]'" :value="line.is_eco_participation ? 1 : 0">
            <input type="hidden" :name="'lines[' + index + '][is_shipping]'" :value="line.is_shipping ? 1 : 0">
            <input type="hidden" :name="'lines[' + index + '][eco_category_id]'" v-model="line.eco_category_id" v-if="line.eco_category_id">
            <input type="hidden" :name="'lines[' + index + '][eco_parent_line_id]'" v-model="line.eco_parent_line_id" v-if="line.eco_parent_line_id">
            <!-- Seuils de vente : la ligne est refusée tant qu'aucun motif ne la débloque. -->
            <div class="ix-line-limit" v-if="limit_breach">
                <i class="far fa-exclamation-triangle"></i> {{ limit_breach }}
                <button type="button" class="ix-btn link ml-1" @click="unlockLimit" v-if="editable">Débloquer</button>
            </div>
            <div class="ix-line-limit is-unlocked" v-else-if="active_override">
                <i class="far fa-unlock"></i> Seuil forcé : {{ active_override }}
                <button type="button" class="ix-btn link ml-1" @click="lockLimit" v-if="editable">annuler</button>
            </div>
            <input type="hidden" v-if="active_override"
                   :name="'lines[' + index + '][limit_override_reason]'" :value="active_override">
            <!-- Repères de saisie, jamais imprimés : prix d'achat et âge du prix tarif. -->
            <div class="ix-line-insight" v-if="show_insight">
                <span v-if="insight.purchase" v-b-tooltip="tooltip(insight.purchase.label)">Achat {{ currency(insight.purchase.amount) }}</span>
                <template v-if="insight.purchase && insight.selling"> · </template>
                <span v-if="insight.selling">
                    Tarif {{ currency(insight.selling.amount) }}
                    <span v-if="insight.selling.updated_at" :class="{'is-stale': insight.selling.stale}"
                          v-b-tooltip="tooltip(insight.selling.stale ? 'Tarif non mis à jour depuis plus de 12 mois' : 'Dernière mise à jour du prix tarif')">
                        <i class="far fa-exclamation-triangle" v-if="insight.selling.stale"></i> MàJ {{ insight.selling.updated_at }}
                    </span>
                </span>
            </div>

            <input type="hidden" :name="'lines[' + index + '][is_hidden_from_client]'" :value="(canHide || showsHiddenFlag) && line.is_hidden_from_client ? 1 : 0" v-if="model == 'quote'">
            <input type="hidden" :name="'lines[' + index + '][line_type_style]'" :value="line.line_type_style" v-if="model == 'quote' && line.line_type_style">
            <div v-show="is_expanded === true">
                <textarea rows="2" class="form-control form-control-sm mt-2" :disabled="line.is_eco_participation || (editable ? false : true)" placeholder="description, informations complémentaires, .." :name="'lines[' + index + '][description]'" v-model="line.description"></textarea>
            </div>
        </td>
        <td :colspan="(isAutoliquidation == 1 ? 4 : 5) + (showsAvailability ? 2 : 0)" v-if="line.is_title == 1"></td>
        <td v-if="line.is_title != 1">
            <input type="number" :disabled="line.is_eco_participation || (editable ? false : true)" class="form-control form-control-sm" :name="'lines[' + index + '][quantity]'" v-model="line.quantity" @blur="compute" required step="0.001">
            <input type="text"  :disabled="line.is_eco_participation || (editable ? false : true)" class="form-control form-control-sm mt-2" placeholder="unité" :name="'lines[' + index + '][unit]'" v-model="line.unit" v-show="is_expanded === true">


            <small class="ix-line-split-notice" v-if="split_quantity_notice"
                   v-b-tooltip="tooltip(split_quantity_notice, 'bottom')">
                <i class="far fa-layer-group"></i> {{ article_total_quantity }} au total
            </small>

            <input type="hidden" v-if="line.is_eco_participation || (editable ? false : true)" v-model="line.quantity" :name="'lines[' + index + '][quantity]'"/>
            <input type="hidden" v-if="line.is_eco_participation || (editable ? false : true)" v-model="line.unit" :name="'lines[' + index + '][unit]'"/>
        </td>
        <!-- Disponibilité, jamais imprimée : le stock, puis le délai s'il ne couvre pas la quantité. -->
        <template v-if="showsAvailability && line.is_title != 1">
            <td class="text-right text-nowrap">
                <span v-if="availability" :class="availability.stock.color ? 'ix-text-' + availability.stock.color : 'ix-text-secondary'"
                      v-b-tooltip="tooltip(availability.stock.tooltip)">
                    {{ availability.stock.label }}<i class="far fa-layer-group ml-1" v-if="availability.stock.tooltip"></i>
                </span>
            </td>
            <td>
                <template v-if="availability">
                    <span class="ix-badge green" v-if="availability.status === 'available'">Disponible</span>
                    <!-- Une part en commande fournisseur : en une ligne, le détail des commandes en infobulle. -->
                    <template v-else-if="availability.incoming">
                        <a :href="incomingInfo.url" target="_blank" class="ix-badge" :class="incomingInfo.late ? 'red' : 'orange'" v-if="incomingInfo.url"
                           v-b-tooltip="tooltip(incomingTooltip)">{{ incomingInfo.label }}</a>
                        <span class="ix-badge" :class="incomingInfo.late ? 'red' : 'orange'" v-else v-b-tooltip="tooltip(incomingTooltip)">{{ incomingInfo.label }}</span>
                        <div class="mt-1" v-if="availability.rest">
                            <span class="ix-badge" :class="availability.rest.lead_time ? 'orange' : 'grey'" v-b-tooltip="tooltip(restTooltipText)">{{ restLabel }}</span>
                        </div>
                    </template>
                    <span class="ix-badge orange" v-else-if="availability.status === 'delay'"
                          v-b-tooltip="tooltip(availability.leadTime.origin)">Délai fournisseur : {{ availability.leadTime.days }} j</span>
                    <span class="ix-badge grey" v-else-if="availability.status === 'unknown'"
                          v-b-tooltip="tooltip(availability.limiting ? 'Aucun délai pour le composant ' + (availability.limiting.number || availability.limiting.name) : 'Aucun délai de référence ni fournisseur')">Délai non renseigné</span>
                </template>
            </td>
        </template>
        <td v-if="line.is_title != 1" class="ix-line-origin-cell">
            <div class="input-group input-group-sm" v-b-tooltip="tooltip(amount_origin_label)">
                <input type="number" class="form-control text-right"  :disabled="line.is_eco_participation || (editable ? false : true)" :name="'lines[' + index + '][amount]'" v-model="line.amount" @blur="compute" required step="0.001">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">€</span>
                </div>
                <span class="ix-line-origin is-warning" v-if="public_price_gap"></span>
            </div>


            <input type="hidden" v-if="line.is_eco_participation || (editable ? false : true)" v-model="line.amount" :name="'lines[' + index + '][amount]'"/>
        </td>
        <td v-if="line.is_title != 1" class="ix-line-origin-cell">
            <div class="input-group input-group-sm" v-b-tooltip="tooltip(discount_origin_label)">
                <input type="number" class="form-control text-center"  :disabled="line.is_eco_participation || (editable ? false : true)" :name="'lines[' + index + '][discount]'" v-model="line.discount" @blur="compute" required min="0" step="0.001">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                </div>
                <span class="ix-line-origin"
                      :class="{'is-edited': discount_differs_from_suggestion}"
                      v-if="has_suggested_discount"></span>
            </div>


            <input type="hidden" v-if="line.is_eco_participation || (editable ? false : true)" v-model="line.discount" :name="'lines[' + index + '][discount]'"/>
        </td>
        <td class="text-right" v-if="line.is_title != 1">{{ currency(line.total_ht) }}</td>
        <td v-if="line.is_title != 1 && isAutoliquidation != 1">
            <div class="input-group input-group-sm">
                <input type="number"  :disabled="editable ? false : true" class="form-control text-center" :name="'lines[' + index + '][vat]'"  v-model="line.vat" @blur="compute" required min="0" step="0.01">
                <div class="input-group-append">
                    <span class="input-group-text" id="inputGroup-sizing-sm">%</span>
                </div>
            </div>

            <input type="hidden" v-if="editable ? false : true" v-model="line.vat" :name="'lines[' + index + '][vat]'"/>
        </td>
        <td class="text-right">
            <span class="btn btn-sm transparent" v-if="canHide" @click="toggleHiddenFromClient"
                v-b-tooltip.hover :title="line.is_hidden_from_client ? 'Ligne masquée dans le devis client : cliquer pour l\'afficher' : 'Masquer cette ligne dans le devis client'">
                <i class="far" :class="line.is_hidden_from_client ? 'fa-eye-slash' : 'fa-eye'"></i>
            </span>
            <span class="btn btn-sm transparent" v-else-if="showsHiddenFlag"
                v-b-tooltip.hover title="Ligne masquée dans le devis client (masquage désactivé dans les paramètres)">
                <i class="far fa-eye-slash"></i>
            </span>

            <span class="btn btn-sm transparent" @click="expandRow">
                <i class="far fa-chevron-up" v-if="is_expanded === true"></i>
                <i class="far fa-chevron-down" v-if="is_expanded === false"></i>
            </span>

            <span class="btn btn-sm transparent" @click="emitEventLineDeleted"  v-show="!line.is_eco_participation && editable">
                <i class="far fa-trash"></i>
            </span>
        </td>
    </tr>
</template>

<script>
    import $ from 'jquery'
    import Swal from "sweetalert2";
    import { blockingBreach, limitBreach, tierFor } from '../../pricing';
    import { incomingText, restText, restTooltip } from './lineAvailability';

    export default {
        name: 'line-form',
        props: ['line', 'index', 'discount', 'isAutoliquidation', 'suggestionsRoute', 'model', 'id', 'tva', 'editable', 'companyId', 'recomputeToken', 'articleQuantities', 'canCreateArticle', 'insight', 'canHide', 'isProtectedArticle', 'showsHiddenFlag', 'showsAvailability', 'availability'],
        data() {
            return {
                errors: [],
                is_expanded: false,
                suggestions: [],
                globalTva: this.tva,
            };
        },
        watch: {
            discount: function () {
                this.compute();
            },
            // Le parent a réécrit la remise de la ligne : les totaux suivent.
            recomputeToken: function () {
                this.compute();
            },
            isAutoliquidation: function (newVal, oldVal) {
                if (newVal == 1) {
                    this.line.vat = 0;
                    this.compute();
                }
            },
            tva: function(newVal, oldVal){
                if(newVal != oldVal){
                    this.globalTva = newVal;
                    this.line.vat = this.globalTva;
                    this.compute();
                }
            },
            'line.quantity': function(newVal, oldVal) {
                if (newVal !== oldVal && !this.line.is_eco_participation && this.line.article_id) {
                    const parsedNew = parseFloat(newVal);
                    if (!Number.isFinite(parsedNew)) {
                        return;
                    }

                    const parsedOld = parseFloat(oldVal);
                    const fallbackOld = Number.isFinite(this.line._last_valid_quantity) ? this.line._last_valid_quantity : parsedNew;

                    this.$emit('update-eco-lines-quantity', {
                        parentUniq: this.line.uniq,
                        newQuantity: parsedNew,
                        oldQuantity: Number.isFinite(parsedOld) ? parsedOld : fallbackOld
                    });

                    this.line._last_valid_quantity = parsedNew;
                }
            }
        },
        computed: {
            /** La part en réception de la ligne, dite en quelques mots (lineAvailability.js). */
            incomingInfo() {
                return incomingText(this.availability.incoming, this.availability.unit);
            },
            incomingTooltip() {
                const availability = this.availability;
                // Un kit n'a pas de commande propre : l'infobulle nomme le composant qui donne la date.
                if (availability.limiting) {
                    return 'Composant ' + (availability.limiting.number || availability.limiting.name) + (this.incomingInfo.late ? '\nEn retard' : '')
                        + '\n' + (availability.incoming.date ? 'Livraison souhaitée sur la commande' : 'Date non renseignée sur la commande');
                }

                return this.incomingInfo.tooltip;
            },
            restLabel() {
                return restText(this.availability.rest, this.availability.unit);
            },
            restTooltipText() {
                return restTooltip(this.availability.rest);
            },
            /** Une ligne d'article, hors éco-participation et titre, avec au moins un repère. */
            show_insight() {
                return !!this.insight && !!this.line.article_id && !this.line.is_eco_participation && this.line.is_title != 1
                    && !!(this.insight.purchase || this.insight.selling);
            },
            hover_label: function(){
                 let str = '';
                if(this.line.amount != 0)
                    str = 'Impossible de transformer cette ligne en titre car le montant est différent de 0,00€';
                else if(this.line.is_title)
                    str = '';
                else
                    str = 'Transformer cette ligne en titre';

                return str;
            },
            // La cascade ne pose que la remise : c'est le seul champ qui porte sa pastille.
            has_suggested_discount: function() {
                return this.line.suggested_field === 'discount';
            },
            /** La remise posée par la cascade a été retouchée à la main. */
            discount_differs_from_suggestion: function() {
                if (this.line.suggested_discount === null || this.line.suggested_discount === undefined) {
                    return false;
                }

                return Math.abs(parseFloat(this.line.discount || 0) - parseFloat(this.line.suggested_discount)) >= 0.0001;
            },
            /**
             * Le PU s'écarte du prix public actuel de l'article : saisi à la main, ou devis
             * établi sur un ancien tarif. La remise de la cascade s'applique quand même dessus.
             */
            public_price_gap: function() {
                if (this.line.is_eco_participation || !this.line.article_id
                    || this.line.public_price === null || this.line.public_price === undefined) {
                    return false;
                }

                return Math.abs(parseFloat(this.line.amount || 0) - parseFloat(this.line.public_price)) >= 0.0001;
            },
            limit_breach: function() {
                return blockingBreach(this.line);
            },
            // Le motif ne vaut que tant qu'il couvre un franchissement réel, et c'est cette
            // valeur, pas celle du champ, qui part au serveur.
            active_override: function() {
                var breach = limitBreach(this.line);

                return breach && this.line.limit_override_for === breach && this.line.limit_override_reason
                    ? this.line.limit_override_reason
                    : '';
            },
            article_total_quantity: function() {
                var totals = (this.articleQuantities || {})[this.line.article_id];

                return totals ? this.quantity(totals.quantity) : '';
            },
            /**
             * Le palier s'apprécie ligne par ligne : six puis six unités ne déclenchent pas
             * celui de dix. C'est un piège classique, donc il est dit, et seulement quand il
             * peut coûter quelque chose : un article à paliers, posé sur plusieurs lignes.
             */
            split_quantity_notice: function() {
                if (!this.line.article_id || this.line.is_eco_participation || this.line.is_title) {
                    return '';
                }

                var totals = (this.articleQuantities || {})[this.line.article_id];
                if (!totals || totals.count < 2) {
                    return '';
                }

                var hasTiers = this.line.pricing
                    && (this.line.pricing.tiers || []).some(function (tier) {
                        return parseFloat(tier.from) > 1;
                    });

                if (!hasTiers) {
                    return '';
                }

                return 'Cet article figure sur ' + totals.count + ' lignes de ce document, pour '
                    + this.quantity(totals.quantity) + ' au total. Les quantités ne sont pas '
                    + 'cumulées : le palier s\'apprécie ligne par ligne.';
            },
            kit_label: function() {
                var count = this.line.kit ? this.line.kit.components.length : 0;

                return 'Article composé · ' + count + (count > 1 ? ' composants' : ' composant');
            },
            // La mention ne s'affiche que sur la cellule qui porte la pastille.
            amount_origin_label: function() {
                return this.public_price_gap
                    ? 'PU différent du prix tarif actuel (' + this.currency(this.line.public_price) + ')'
                    : '';
            },
            discount_origin_label: function() {
                return this.has_suggested_discount ? this.origin_label : '';
            },
            origin_label: function() {
                if (!this.line.suggested_label) {
                    return '';
                }

                return this.discount_differs_from_suggestion
                    ? this.line.suggested_label + '\n(remise modifiée)'
                    : this.line.suggested_label;
            }
        },
        methods : {
            /**
             * La fenêtre comme limite, et non le tableau : sur un document d'une seule ligne,
             * Popper n'a pas la place au-dessus et rabat l'infobulle sur le champ qu'elle
             * explique. La classe lui donne sa largeur, le tableau ne la contraint plus.
             */
            tooltip: function(title, placement) {
                return {
                    title: title,
                    trigger: 'hover',
                    placement: placement || 'top',
                    boundary: 'window',
                    customClass: 'ix-line-tooltip',
                };
            },
            /** Une quantité avec son unité, sans décimales inutiles : « 12 U » et non « 12,000 ». */
            quantity: function(value) {
                var parsed = parseFloat(value) || 0;
                var formatted = parsed.toFixed(3).replace(/\.?0+$/, '').replace('.', ',');

                return formatted + (this.line.unit ? ' ' + this.line.unit : '');
            },
            /** La loi prévoit des exceptions à la vente à perte : le motif en tient lieu. */
            unlockLimit: function() {
                var breach = limitBreach(this.line);

                Swal.fire({
                    title: 'Forcer ce seuil de vente',
                    html: breach + '<br><small>Le motif est enregistré dans le journal du document, avec votre nom.</small>',
                    icon: 'warning',
                    input: 'text',
                    inputPlaceholder: 'Motif (déstockage, fin de série, ...)',
                    inputValidator: (value) => {
                        return value && value.trim() !== '' ? null : 'Un motif est obligatoire.';
                    },
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Forcer le seuil',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        // Le motif ne couvre que ce franchissement précis : la ligne se
                        // rebloque si la quantité ou le prix change après coup.
                        this.line.limit_override_for = breach;
                        this.line.limit_override_reason = result.value.trim();
                    }
                });
            },
            lockLimit: function() {
                this.line.limit_override_for = null;
                this.line.limit_override_reason = null;
            },
            expandRow: function() {
                this.is_expanded = !this.is_expanded;
            },
            toggleKit: function() {
                this.line.kit_open = !this.line.kit_open;
                this.$emit('kit-toggled', this.line);
            },
            toggleHiddenFromClient: function() {
                if (!this.editable) {
                    return;
                }
                this.$set(this.line, 'is_hidden_from_client', !this.line.is_hidden_from_client);
            },
            compute: function() {
                // Prévention champs vide
                if (this.line.quantity == '' || this.line.quantity == null) { this.line.quantity = 0 }
                if (this.line.amount == '' || this.line.amount == null) { this.line.amount = 0 }
                if (this.line.discount == '' || this.line.discount == null) { this.line.discount = 0 }
                if ((this.line.vat === '' || this.line.vat === null ) && !this.line.is_title) { this.line.vat = this.globalTva ? this.globalTva : 0 }

                // Le palier se joue avant les totaux : ils doivent porter le prix retenu.
                this.refreshPricing();


                if (this.line.is_title) {
                    this.line.quantity = 1;
                    this.line.unit = null;
                    this.line.amount = 0;
                    this.line.discount = 0;
                    this.line.total_ht = 0;
                    this.line.total_discount = 0;
                    this.line.total_after_discount = 0;
                    this.line.total_vat = 0;
                    this.line.total_ttc = 0;
                    this.line.article_id = null;
                    this.line.kit = null;
                } else {
                    var price = parseFloat(this.line.quantity) * parseFloat(this.line.amount);
                    var discount = parseFloat(this.line.discount) !== 0 ? ((price / 100) * parseFloat(this.line.discount)) : 0;
                    this.line.total_ht = price - discount;

                    if (this.discount && !this.line.is_eco_participation) {
                        this.line.total_discount = (this.line.total_ht / 100) * this.discount
                        this.line.total_after_discount = this.line.total_ht - this.line.total_discount;
                    } else {
                        this.line.total_discount = 0;
                        this.line.total_after_discount = this.line.total_ht;
                    }
                    
                    this.line.total_after_discount = parseFloat(this.line.total_after_discount) || 0;
                    this.line.vat = parseFloat(this.line.vat) || 0; 
                    this.line.total_vat = parseFloat((this.line.total_after_discount * (this.line.vat / 100)).toFixed(2));
                    this.line.total_ttc = parseFloat((this.line.total_after_discount + this.line.total_vat).toFixed(2));

                }

                if (this.model == 'creditnote') {
                    this.line.total_ht = this.line.total_ht * -1;
                    this.line.total_after_discount = this.line.total_after_discount * -1;
                    this.line.total_vat = this.line.total_vat * -1;
                    this.line.total_ttc = this.line.total_ttc * -1;
                }

                setTimeout(() => {
                    this.updateLinesUnderTotal();
                }, 100);


            },
            updateLinesUnderTotal: function(){
                this.$emit('line-under-total-edited', {line : this.line});
            },
            updateLineTva: function(){

            },
            emitEventLineEdited: function () {
                this.$emit('line-editing-started', this.index)
            },
            /** Une copie de l'article de la ligne, ou un article neuf repris de la saisie libre. */
            openArticleModal() {
                var source = this.line.article_id
                    ? { article_id: this.line.article_id, article_name: this.line.designation }
                    : {
                        designation: this.line.designation,
                        reference: this.line.reference,
                        unit: this.line.unit,
                        description: this.line.description,
                        amount: this.line.amount != 0 ? this.line.amount : null,
                    };

                this.$emit('open-article-modal', { source: source, done: article => this.loadArticle(article.id) });
            },
            /** L'article créé arrive comme une suggestion choisie : tarif du client, remise, éco et composition. */
            loadArticle(articleId) {
                $.ajax({
                    url: this.suggestionsRoute,
                    type: 'get',
                    dataType: 'json',
                    headers: this.getHttpJsonRequestHeaders().headers,
                    data: { article_id: articleId, deal_id: $('#deal_id').val(), company_id: this.companyId, [this.model + '_id']: this.id },
                    success: (data) => {
                        if (!data.length) return;

                        this.fillLineProperties(data[0]);
                        this.compute();
                        this.emitEventLineEdited();
                    }
                });
            },
            emitEventLineDeleted: function () {
                Swal.fire({
                    title: 'Êtes-vous sûr ?',
                    text: "",
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: 'Annuler',
                    confirmButtonColor: '#D15240',
                    confirmButtonText: 'Oui, supprimer',
                    reverseButtons: true,
                    heightAuto: false
                }).then((result) => {
                    if (result.value) {
                        this.$emit('line-deleted', this.index)
                    }
                })
            },
           fillLineProperties(item) {
                this.line.reference = item.reference;
                this.line.designation = item.designation;
                this.line.unit = item.unit;
                this.line.amount = item.amount;
                this.line.description = item.description;
                this.line.is_title = item.is_title;
                this.line.parent_id = item.parent_id;
                this.line.article_id = item.article_id ? item.article_id : null;
                this.line.public_price = item.public_price !== undefined ? item.public_price : null;
                // La composition du jour ; le serveur la fige à l'enregistrement.
                this.line.kit = item.kit || null;
                this.line.kit_open = false;

                // Pré-remplissage tarifaire : seuls les articles en portent un, une ligne
                // reprise d'un document précédent ou un prix de catalogue garde son taux.
                this.applyPricing(item);

                // Les seuils suivent l'article : un motif ne survit pas à son changement.
                this.line.minimum_order_quantity = item.minimum_order_quantity !== undefined
                    ? item.minimum_order_quantity
                    : null;
                this.line.minimum_selling_price = item.minimum_selling_price !== undefined
                    ? item.minimum_selling_price
                    : null;
                this.lockLimit();

                // L'éco arrive calculée par le serveur (EcoParticipationCalculator) : une ligne
                // par entrée, celles de l'article précédent retirées.
                this.removeEcoLinesForArticle(this.line.uniq);
                (item.eco || []).forEach(entry => this.addEcoLine(entry));
            },
            /**
             * Les paliers arrivent résolus du serveur : le taux et la mention d'origine sont
             * pris tels quels, rien n'est recalculé ici.
             */
            applyPricing(item) {
                this.line.pricing = item.pricing || null;

                if (this.line.pricing) {
                    this.applySuggestion(this.pricingTierFor(this.line.quantity));
                    return;
                }

                // Pas de règle tarifaire sur l'article : la grille du profil, comme au 5.3.
                this.applyGridDiscount(item.discount, item.discount_label);
            },
            pricingTierFor(quantity) {
                return tierFor(this.line.pricing, quantity);
            },
            /**
             * L'origine n'est pas stockée sur la ligne, elle vit le temps de la saisie. Le PU
             * n'est jamais touché : la cascade ne décide que de la remise.
             */
            applySuggestion(tier) {
                if (!tier) {
                    this.clearSuggestion();
                    return;
                }

                this.line.suggested_discount = parseFloat(tier.discount);
                this.line.suggested_field = tier.field || null;
                this.line.suggested_label = tier.label;
                this.line.discount = parseFloat(tier.discount);
            },
            clearSuggestion() {
                this.line.pricing = null;
                this.line.suggested_discount = null;
                this.line.suggested_field = null;
                this.line.suggested_label = null;
            },
            applyGridDiscount(rate, label) {
                if (rate === null || rate === undefined) {
                    this.clearSuggestion();
                    return;
                }

                this.line.suggested_discount = parseFloat(rate);
                this.line.suggested_field = 'discount';
                this.line.suggested_label = label;
                this.line.discount = parseFloat(rate);
            },
            /**
             * Le palier suit la quantité, sauf si la remise a été reprise à la main : une
             * remise saisie volontairement ne doit pas disparaître au premier ajustement.
             */
            refreshPricing() {
                if (!this.line.pricing || this.line.is_eco_participation) {
                    return;
                }

                if (this.discount_differs_from_suggestion) {
                    return;
                }

                this.applySuggestion(this.pricingTierFor(this.line.quantity));
            },
            removeEcoLinesForArticle(articleUniq) {
                this.$emit('remove-eco-lines-for-article', articleUniq);
            },
            /**
             * Une ligne d'éco sous la ligne, au montant calculé par le serveur. Le lien est
             * eco_parent_* : parent_id reste la filiation des transformations.
             */
            addEcoLine(entry) {
                const unitAmount = parseFloat(entry.unit_amount) || 0;

                this.$emit('add-eco-line', {
                    uniq: Date.now() + Math.random(),
                    parent_id: null,
                    parent_uniq: this.line.uniq,
                    eco_parent_line_id: this.line.id || null,
                    eco_parent_uniq: this.line.uniq,
                    is_eco_participation: true,
                    eco_category_id: entry.eco_category_id,
                    eco_rate_amount: unitAmount,
                    eco_unit_amount: unitAmount,
                    reference: '',
                    designation: entry.designation,
                    quantity: parseFloat(this.line.quantity) || 1,
                    unit: '',
                    amount: unitAmount,
                    discount: 0,
                    vat: this.globalTva || 20,
                    is_title: false,
                    article_id: null
                });
            }
        },
        mounted() {
            // Expand si description
            if (this.line.description) {
                this.is_expanded = true;
            }

            this.compute()

            var modelKey = this.model + "_id"

            // Creation autocomplete
            $("#suggestionAutocomplete" + this.line.uniq).autocomplete({
                minLength: 2,
                source: (request, response) => {
                    $.ajax({
                        url : this.suggestionsRoute,
                        type: 'get',
                        dataType : 'json',
                        headers: this.getHttpJsonRequestHeaders().headers,
                        data: {...{ q: request.term }, ...{deal_id: $('#deal_id').val()}, ...{company_id: this.companyId}, ...{[modelKey]: this.id}},
                        success: (data) => {
                            response($.map(data, (item) => {
                                return Object.assign(item, {
                                    label: item.designation,
                                    value: item.designation,
                                    formatted_amount: this.currency(item.amount)
                                });
                            }));
                        }
                    });
                },
                change: (e, item) => {
                    if(!item.item){
                        this.line.parent_id = null
                        this.line.article_id = null
                        this.line.kit = null
                        this.line.public_price = null
                        this.applyGridDiscount(null, null)
                        this.line.minimum_order_quantity = null
                        this.line.minimum_selling_price = null
                        this.lockLimit()
                        // Supprimer les lignes éco-participation si l'article n'est plus sélectionné
                        this.removeEcoLinesForArticle(this.line.uniq)
                    }
                },
                create: function () {
                    $(this).data('ui-autocomplete')._renderItem = function (ul, item) {
                        // Un kit se reconnaît dès la suggestion, comme dans la liste des articles.
                        var badge = item.kit
                            ? '<span class="badge badge-primary">Article composé</span>'
                            : `<span class="badge badge-secondary">${item.category}</span>`;
                        var html = `<div class="d-flex align-items-center">
                                      ${badge}
                                      <span class="ml-2">${item.autocomplete_label}</span>`;

                        if (item.is_title) {
                            html += `</div>`
                        } else {
                            html += `<span class="ml-auto">${item.formatted_amount}</span>
                                    </div>`
                        }

                        return $('<li>')
                            .append(html)
                            .appendTo(ul);
                    };
                },
                select: (e, item) => {
                    this.fillLineProperties(item.item);
                    this.compute()
                }
            }).focus(() => {
                $("#suggestionAutocomplete" + this.line.uniq).autocomplete("search", '');
            });
        }
    }
</script>

<style scoped>
    /* Bloquant, donc visible : la ligne ne peut pas être enregistrée en l'état. */
    .ix-line-limit {
        margin-top: 4px;
        font-size: 12px;
        color: var(--ix-red);
    }

    .ix-line-limit.is-unlocked {
        color: var(--ix-text-secondary);
    }

    .ix-line-insight {
        margin-top: 4px;
        font-size: 12px;
        color: var(--ix-text-secondary);
    }

    .ix-line-insight .is-stale {
        color: var(--ix-orange);
    }

</style>